import axios from "axios";
import React, { useState, useEffect, useContext } from "react";
import M from "materialize-css";
import { StateContext } from "../../App";

function Deposit() {

  const { state, dispatch } = useContext(StateContext);

  const [user, setUser] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    M.AutoInit();
  });

  const wallet_Update = (e) => {
    e.preventDefault();
    
    dispatch({ type: "SET_LOADING", payload: true });

    const form = document.querySelector(".update-wallet-form");
    const searchQuery = form.searchQuery.value;
    const amount = form.amount.value;
    const depositCondition = form.depositCondition.value;
    console.log(searchQuery);
    console.log(amount);
    console.log(depositCondition);

    const options = {
      searchQuery,
      amount,
      depositCondition
    };

    axios
      .post("/admin/all-customers", options)
      .then((result) => {
        console.log(result);
        console.log(result.data);
        setUser(result.data);
        
        result.data.msg && alert("Wallet updated succesfully!");

        form.searchQuery.value = "";
        form.amount.value = "";



        dispatch({ type: "SET_LOADING", payload: false });

      })
      .catch((error) => {
        console.log("ERR! Getting One Customer Detail", error);
        setUser({});
        setError(error);

        dispatch({ type: "SET_LOADING", payload: false });
        
      });
  };




  // Update Bonus Here!

  const bonus_Update = (e) => {
    e.preventDefault();
    
    dispatch({ type: "SET_LOADING", payload: true });

    const form = document.querySelector(".update-bonus-form");
    const searchQuery = form.searchQuery.value;
    const amount = form.amount.value;
    const depositCondition = form.depositCondition.value;
    console.log(searchQuery);
    console.log(amount);
    console.log(depositCondition);

    const options = {
      searchQuery,
      amount,
      depositCondition
    };

    axios
      .post("/admin/bonus", options)
      .then((result) => {
        console.log(result);
        console.log(result.data);
        setUser(result.data);
        
        result.data.msg && alert("Bonus updated succesfully!");

        form.searchQuery.value = "";
        form.amount.value = "";



        dispatch({ type: "SET_LOADING", payload: false });

      })
      .catch((error) => {
        console.log("ERR! Getting One Customer Detail", error);
        setUser({});
        setError(error);

        dispatch({ type: "SET_LOADING", payload: false });
        
      });
  };


  return (
    <div className="deposit-admin">
      <div className="header-withdraw indigo darken-2">
        <button
          data-target="slide-out"
          className="sidenav-trigger Button-menu hide-on-large-only"
        >
          <i className="fas fa-bars"></i>
        </button>
        <h1>Deposit</h1>
      </div>
      {/* <br /> */}
      <div className="container">
        <div className="card indigo darken-2">
          <div className="card-content">
          <h5>Wallet update</h5>
            <form onSubmit={wallet_Update} className="update-wallet-form">
              <div className="row">
                <div className="col s12 m6 l5">
                  <input
                    required
                    type="email"
                    name="searchQuery"
                    placeholder="Enter Customer's Email"
                  />
                </div>
                <div className="col">
                  <div className="divider"></div>
                </div>
                <div className="col s12 m6 l6">
                  <input
                    required
                    type="text"
                    name="amount"
                    placeholder="Enter New Wallet Amount"
                  />
                </div>
                <div className="col s12 m3 l3">
                  <select name="depositCondition" className="browser-default" required>
                    <option value="" defaultValue>Choose wallet update type</option>
                    <option value="add">Add</option>
                    <option value="topUp">Profit Top-up</option>
                    <option value="subtract">subtract</option>
                  </select>
                </div>
                <div className="col s12 m4 l6">
                  <button>Deposit New Amount</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="card indigo darken-2">
          <div className="card-content">
            <h5>Bonus update</h5>
          <form onSubmit={bonus_Update} className="update-bonus-form">
              <div className="row">
                <div className="col s12 m6 l5">
                  <input
                    required
                    type="email"
                    name="searchQuery"
                    placeholder="Enter Customer's Email"
                  />
                </div>
                <div className="col">
                  <div className="divider"></div>
                </div>
                <div className="col s12 m6 l6">
                  <input
                    required
                    type="text"
                    name="amount"
                    placeholder="Enter BONUS Amount"
                  />
                </div>
                <div className="col s12 m3 l3">
                  <select name="depositCondition" className="browser-default" required>
                    <option value="" defaultvalue>Choose bonus update type</option>
                    <option value="add">Add</option>
                    <option value="subtract">subtract</option>
                  </select>
                </div>
                <div className="col s12 m4 l6">
                  <button>Deposit New Amount</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Deposit;
